import Vue from "vue";
import Component from "vue-class-component";
import environmentVariables from '../../../../environmentVariables'

const FooterProps = Vue.extend({
  props: {
    logo: {
      type: String,
      required: true,
    },
  },
});

@Component({
  name: "Footer",
})
export default class Footer extends FooterProps {
  cx_logo = this.logo;
  cx_version = environmentVariables.APP_VERSION;

  mounted() {
    this.cx_logo = this.logo;
    this.initOnScroll();
  }

  initOnScroll() {
    window.onscroll = () => {
      this.scroll();
    };
  }
  scroll() {
    const btn = this.$refs.button as HTMLButtonElement;

    if (!btn) {
      return;
    }

    if (document.documentElement.scrollTop > 150) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  }
}
